module.exports = __webpack_public_path__ + "static/media/home-bg.ec445c1f.jpg";